require('../../modules/es.map');
require('../../modules/esnext.map.filter');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Map', 'filter');
